<template>
  <div>
    <!-- 
      Form Cancel Bet
    -->
    <v-card class="py-4">
      <div style="max-width: 600px; margin: 0 auto">
        <v-form ref="form" v-model="valid" :lazy-validation="lazy">
          <v-card-text class="pb-0">
            <div class="pb-4 subtitle-1">{{ $t("digitCodeBet") }}</div>
            <v-alert v-model="alert" type="warning" text outlined dismissible>{{
              alertMsg
            }}</v-alert>
            <v-text-field
              solo-inverted
              v-model="codBet"
              :rules="[codBetRules, required]"
              :label="$t('code')"
              required
              clearable
              hide-details
              autofocus
            ></v-text-field>
          </v-card-text>
          <v-card-actions class="pa-4">
            <v-spacer></v-spacer>
            <v-btn
              depressed
              color="info"
              :loading="loading"
              type="submit"
              :disabled="!valid"
              @click.prevent="validate"
              >{{ $t("next") }}</v-btn
            >
          </v-card-actions>
        </v-form>
      </div>
    </v-card>

    <!-- 
      Diaglog > BetCard
    -->
    <v-dialog
      v-model="dialog"
      scrollable
      max-width="600px"
      :fullscreen="this.$vuetify.breakpoint.xsOnly"
      light
    >
      <v-card>
        <v-toolbar max-height="64" elevation="0" class="transparent">
          <v-toolbar-title>{{ $t("cancelBet") }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-divider></v-divider>

        <v-card-text style="height: auto" class="pa-2 grey darken-3">
          <!-- 
            Component betCard 
          -->
          <BetCard />
        </v-card-text>

        <v-divider></v-divider>
        <!-- 
          Alert Cancel Bet
        -->
        <v-alert
          v-model="alert2"
          type="warning"
          text
          outlined
          class="mx-4 mt-4 mb-0"
          >{{ $t("betAttencion") }}</v-alert
        >
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn text @click="dialog = false">{{ $t("close") }}</v-btn>
          <v-btn
            depressed
            color="success"
            :loading="loading2"
            @click="confirmCancel"
            >{{ $t("confirmCancelBet") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import BetCard from "@/components/agent/Backoffice/bet/BetCard";
export default {
  name: "ViewAgentBetPay",
  components: {
    BetCard,
  },
  data: () => ({
    valid: true,
    loading: false,
    loading2: false,
    codBet: "",
    dialog: false,
    lazy: false,
    betData: "",
    alert: false,
    alertMsg: "",
    alert2: true,
  }),
  computed: {
    codBetRules() {
      return (v) => /^\d+$/.test(v) || this.$t("validCode");
    },
    required() {
      return (v) => !!v || this.$t("required");
    },
  },

  methods: {
    // Validate Cancel Bet Flow
    // 1. getBetAgent - Open Dialog to confirm cancel bet;
    // Important: required 'printed: 0'
    validate() {
      if (this.$refs.form.validate()) {
        this.$store.commit("setFeedbackProgress", true);
        this.loading = true;

        const params = {
          id_bet: this.codBet,
          printed: 0,
        };

        this.$axios
          .post("agent/bets/getBetAgent", this.$formdata(params))
          .then((resp) => {
            if (resp.status === 200) {
              this.betData = resp.data.dados[0];
              // Open Bet Card:
              this.dialog = true;
              this.$store.commit("setBetCard", this.betData);
            }
          })
          .catch((err) => {
            if (err.response.data.status === 400) {
              // alert static
              this.alert = true;
              this.alertMsg = err.response.data.messages.error;
            }
          })
          .finally(() => (this.loading = false));
      }
    },

    // 2. Confirm Cancel Bet
    confirmCancel() {
      this.$store.commit("setFeedbackProgress", true);
      this.loading2 = true;

      const params = {
        id_bet: this.codBet,
      };

      this.$axios
        .post("agent/bets/cancelBet", this.$formdata(params))
        .then((resp) => {
          if (resp.status === 200) {
            this.dialog = false;

            // FeedBack Dialog Success!
            this.$store.commit("setFeedbackDialog", {
              title: this.$t("betCode") + this.codBet + this.$t("betCancel"),
              msg: resp.data.messages,
              type: "success",
              shareBetPDF: false,
              action: "",
            });
            this.$store.commit("setCash", resp.data.credit_current);
            this.$refs.form.reset();
          }
        })
        .catch((err) => {
          if (err.response == undefined) return;
          if (err.response.data.status == 400) {
            this.dialog = false;
            // alert static
            this.alert = true;
            this.alertMsg = err.response.data.messages.error;
          }
        })
        .finally(() => (this.loading2 = false));
    },
  },
};
</script>
